import Phaser from "phaser"


export default class Instruction extends Phaser.Scene {

    preload() {
        this.load.audio('click-sound', require('../../assets/sounds/click.mp3'));
        this.load.image("instruction-background", require('./assets/background.png'));
        this.load.image("instruction-content", require('./assets/instruction.png'));
        
        this.load.image("leaderboard-backBtn-border", require('../../assets/back-button.png'));
    }
    create() {
        this.clickSound = this.sound.add('click-sound', { volume: 0.5, loop: false });
        this.soundConfig();
        // this.add.image(0, 0, "instruction-background").setOrigin(0, 0);
       
        this.add.rectangle(0, 0, 1080,1920, 0xF2F2F2).setOrigin(0, 0)
            var components = [];
            // components.push()
            components.push(this.add.image(0, 0, "instruction-background").setOrigin(0, 0))
            components.push(this.add.image(0, 400, "instruction-content").setOrigin(0, 0))
            components.push(this.add.text((1080 / 2), 100, "Instructions", {
                color: '#F05B45',
                boundsAlignH: "center", boundsAlignV: "middle",
                font: '600 75px Rockridge'
            }).setOrigin(0.5, 0.5).setAlign('center').setFixedSize(800,80))
            


            var instructionContainer = this.add.container(0, 0, components);
            instructionContainer.setSize(5000, 10000);
            instructionContainer.setInteractive();
            this.input.setDraggable(instructionContainer);

            this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
                if (dragY < 0 && dragY > -850) {
                    gameObject.y = dragY;
                }
            });

            this.backBtn = this.add.image(100, 100, "leaderboard-backBtn-border").setScale(0.2);
            this.backBtn.setInteractive();
            this.backBtn.on('pointerdown', (pointer) => {
                this.clickSound.play();
                this.scene.start('Introduction');
            });
    }
    soundConfig(){
        this.clickSound.mute = !this.game.config.soundSetting;
    }

    update() {

    }

}